import type { GetSessionRefreshTokenProps } from "./getSessionRefreshToken";
import { getSessionRefreshToken } from "./getSessionRefreshToken";

export type GetSessionHasRefreshTokenProps = GetSessionRefreshTokenProps;

export const getSessionHasRefreshToken = ({
  ...props
}: GetSessionHasRefreshTokenProps) =>
  typeof getSessionRefreshToken(props).refreshToken === "string";
